var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Visa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-jcb-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    rx: 2,
    ry: 2,
    style: {
      fill: "#2464b4"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6338",
    d: "M16.44,9.09h1.1a.44.44,0,0,0,.34-.44.44.44,0,0,0-.34-.43h-1.1v.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6349",
    d: "M17.3,2.91a1.69,1.69,0,0,0-1.69,1.7V6.37h2.56c.54,0,.94.31.94.79a.79.79,0,0,1-.77.77V8c.55,0,1,.35,1,.82s-.47.85-1.08.85H15.6v3.45h2.49a1.69,1.69,0,0,0,1.69-1.7V2.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6360",
    d: "M17.76,7.28a.4.4,0,0,0-.35-.4h-1v.82h.88s.09,0,.09,0A.39.39,0,0,0,17.76,7.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6371",
    d: "M7.92,2.91a1.69,1.69,0,0,0-1.69,1.7V8.79a3.24,3.24,0,0,0,1.46.38.8.8,0,0,0,.9-.83v-2h1.46v2c0,.76-.48,1.39-2.09,1.39A6.93,6.93,0,0,1,6.22,9.5v3.57H8.71a1.69,1.69,0,0,0,1.69-1.69V2.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6384",
    d: "M12.61,2.91a1.69,1.69,0,0,0-1.69,1.7V6.83a3.35,3.35,0,0,1,2.37-.55,7.55,7.55,0,0,1,1.34.21v.72a3.27,3.27,0,0,0-1.29-.38c-.91-.06-1.46.39-1.46,1.17s.55,1.24,1.46,1.17a3.45,3.45,0,0,0,1.29-.38v.72a7.36,7.36,0,0,1-1.34.21,3.35,3.35,0,0,1-2.37-.55v3.92h2.49a1.69,1.69,0,0,0,1.69-1.7V2.91Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.0c0155c8c8406dc62566fe1d2be4de9c.svg";
export { ForwardRef as ReactComponent };